import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Models
import mDistribution from 'models/distribution';
// Custom
import { getDistributionsAutocomplete } from 'actions';
import { distributionDataShape, autoCompleteDataShape } from 'constants/PropTypesShapes';
import AutoCompleteSearchFieldFilter from 'components/filters/AutoCompleteSearchFieldFilter';
import InformationItem from 'components/items/InformationItem';

const DistributionAutoCompleteItem = ({ element, onSelect }) => {
  if (element) {
    const distribution = { ...element };

    return (
      <div className="information-item-wrapper">
        <InformationItem
          icon={mDistribution.icon}
          label={<LocalizedMessage id="info.distributionDependencies" values={{ devicesQtity: distribution.devices_quantity, rolloutsQtity: distribution.rollouts_quantity }} />}
          value={mDistribution.fullDesc(distribution)}
          onClick={() => onSelect(distribution)}
        />
      </div>
    );
  }
  return null;
};

DistributionAutoCompleteItem.propTypes = {
  element: distributionDataShape,
  onSelect: PropTypes.func,
};

DistributionAutoCompleteItem.defaultProps = {
  element: null,
  onSelect: null,
};

class DistributionAutoCompleteFilter extends React.Component {
  constructor(props) {
    super(props);

    this.handleGetDistributions = this.handleGetDistributions.bind(this);
    this.handleSelectElement = this.handleSelectElement.bind(this);
  }

  // Handlers
  handleGetDistributions(value, page) {
    const { handleGetDistributionsAutocomplete } = this.props;
    // Get default distributions list features
    const { defaultParams: { pagination, sort }, autoCompleteFilter } = mDistribution.listFeatures;
    // Define the page to be loaded
    const finalPagination = {
      page: page || pagination.page,
      pageSize: pagination.pageSize,
    };
    // Launch distributions loading
    const filter = { ...autoCompleteFilter, value };
    handleGetDistributionsAutocomplete(finalPagination, sort, [filter]);
  }

  handleSelectElement(distribution) {
    const { onSelect } = this.props;
    onSelect(distribution);
  }

  render() {
    const { distribution, distributions: { loading, elements, pagination } } = this.props;

    return (
      <AutoCompleteSearchFieldFilter
        label="field.distribution"
        element={distribution}
        loading={loading}
        elements={elements}
        pagination={pagination}
        elementComp={
          <DistributionAutoCompleteItem />
        }
        onGetElements={this.handleGetDistributions}
        elementDescBuilder={(element) => (mDistribution.desc(element))}
        onSelectElement={this.handleSelectElement}
      />
    );
  }
}

DistributionAutoCompleteFilter.propTypes = {
  distribution: distributionDataShape,
  distributions: autoCompleteDataShape.isRequired,
  onSelect: PropTypes.func.isRequired,
  handleGetDistributionsAutocomplete: PropTypes.func.isRequired,
};

DistributionAutoCompleteFilter.defaultProps = {
  distribution: null,
};

const mapStateToProps = (state) => ({
  distributions: state.autoComplete.distributions,
});

const mapDispatchToProps = (dispatch) => ({
  handleGetDistributionsAutocomplete: (pagination, sort, filters) => {
    dispatch(getDistributionsAutocomplete(pagination, sort, filters));
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DistributionAutoCompleteFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/distributions/assets/main/DistributionAutoCompleteFilter.js